import { useMemo } from 'react';
import { connect } from 'react-redux';

import CurrencySign from 'components/price/CurrencySign.component';
import { useTranslation } from 'providers/GILT.provider';

const EmailItem = ({ item, itemType, tableStyle, recipient, categories, stylists, products }) => {
  const { t } = useTranslation();

  const resolvedItem = useMemo(() => {
    if (itemType === 'service') {
      if (item.id) {
        for (let i = 0; i < categories.length; i += 1) {
          for (let j = 0; j < categories[i].services.length; j += 1) {
            if (item.id === categories[i].services[j].id) {
              return categories[i].services[j];
            }
          }
        }
        if (!item) {
          return {
            title: 'composite.email.emailItem.service',
            price: parseFloat(item.price),
          };
        }
      } else {
        return {
          currency: '',
          duration: '',
          name: 'composite.email.emailItem.service',
          order: 0,
          price: item.price ? item.price : item.finalPrice,
          salon_id: -1,
          service_category_id: -1,
          status: '',
          stylist_id: item.stylistId,
        };
      }
    } else if (item.id) {
      return (
        products.find((prod) => prod.id === item.id) || {
          title: item.title,
          price: parseFloat(item.price),
        }
      );
    } else {
      return {
        title: item.title,
        price: parseFloat(item.price),
      };
    }
  }, [categories, item, itemType, products]);

  const stylist = useMemo(() => {
    if (!item?.stylistId) return null;
    return stylists.find((s) => s.id === item.stylistId);
  }, [item?.stylistId, stylists]);

  const { fullPrice, discount } = useMemo(() => {
    if (!item) return { fullPrice: 0, discount: 0 };

    if (item.discountType === 'absolute') {
      const d = parseFloat(item.discount || 0);
      return {
        discount: d,
        fullPrice: parseFloat(item.finalPrice) + d,
      };
    }

    const calculatedFull = parseFloat(item.finalPrice) / ((100 - item.discount) / 100);

    return {
      fullPrice: calculatedFull,
      discount: calculatedFull - parseFloat(item.finalPrice),
    };
  }, [item]);

  const name = resolvedItem?.name || resolvedItem?.title || '';
  const stylistName = stylist?.user_name || recipient;
  const subtitle = itemType === 'product' ? '' : stylistName;
  const quantity = item?.quantity ? `x ${item.quantity}` : '';
  const displayName =
    itemType === 'product' && name
      ? `${name.charAt(0).toUpperCase() + name.slice(1)} ${quantity}`
      : `${t(name)} ${quantity}`;

  const sEmpty = {
    backgroundColor: ' #fff',
    verticalAlign: 'middle',
  };
  const s21 = {
    borderTop: '1px solid #e5e5e5',
    borderLeft: '1px solid #e5e5e5',
    fontFamily: 'Open Sans,sans-serif',
  };
  const s22 = {
    textAlign: 'left',
    fontSize: '14px',
    fontFamily: 'Open Sans,sans-serif',
    marginBottom: '3px',
    marginLeft: '9px',
  };
  const s23 = {
    display: 'block',
    textAlign: 'left',
    fontSize: '11px',
    fontFamily: 'Open Sans,sans-serif',
    color: '#6b6d6f',
    marginBottom: '10px',
    marginLeft: '9px',
    marginTop: '4px',
  };
  const s24 = {
    textAlign: 'right',
    fontSize: '16px',
    fontFamily: 'Open Sans,sans-serif',
    color: '#080b0f',
    borderTop: '1px solid #e5e5e5',
    borderRight: '1px solid #e5e5e5',
    marginRight: '23px',
    paddingRight: '14px',
  };
  const s25 = {
    border: '1px solid #e5e5e5',
    padding: '15px',
    fontFamily: 'Open Sans,sans-serif',
  };
  const s26 = {
    borderLeft: '3px solid #933cc1',
    fontWeight: 600,
    fontSize: '14px',
    fontFamily: 'Open Sans,sans-serif',
    color: '#080b0f',
    padding: '6px 0 6px 12px',
  };
  const s27 = {
    textAlign: 'right',
    fontSize: '14px',
    fontFamily: 'Open Sans,sans-serif',
    color: '#6b6d6f',
  };

  const s28 = {
    borderLeft: '3px solid #933cc1',
    fontWeight: 600,
    fontSize: '14px',
    fontFamily: 'Open Sans,sans-serif',
    color: '#080b0f',
    padding: '6px 0 6px 12px',
  };
  const s29 = {
    textAlign: 'right',
    fontSize: '14px',
    fontFamily: 'Open Sans,sans-serif',
    color: '#6b6d6f',
  };

  const s34 = {
    textAlign: 'right',
    fontSize: '14px',
    fontFamily: 'Open Sans,sans-serif',
    color: '#fff',
    marginRight: '48px',
  };
  return (
    <table style={tableStyle} cellPadding="5" cellSpacing="10" id="emailContainer">
      <tbody>
        <tr>
          <th height="40" style={s21}>
            <h2 style={s22}>{displayName}</h2>
            <span style={s23}>{subtitle}</span>
          </th>
          {resolvedItem && (
            <th style={s24}>
              <CurrencySign value={fullPrice} />
            </th>
          )}
        </tr>
        <tr>
          <td colSpan="2" style={s25}>
            {item && (
              <table style={tableStyle} cellPadding="8" cellSpacing="0" id="emailContainer">
                <tbody>
                  <tr>
                    <td style={s28}>{t('composite.email.emailItem.discount')}</td>
                    <td style={s29}>
                      <CurrencySign value={discount} />
                    </td>
                  </tr>
                  <tr>
                    <td style={s26}>{t('composite.email.emailItem.subtotal')}</td>
                    <td style={s27}>
                      <CurrencySign value={item.finalPrice} />
                    </td>
                  </tr>
                </tbody>
              </table>
            )}
          </td>
        </tr>
        <tr>
          <td style={sEmpty}>
            <span style={s34}>.</span>
          </td>
          <td style={sEmpty}>
            <span style={s34}>.</span>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

EmailItem.defaultProps = {
  recipient: null,
};

const mapStateToProps = (state) => ({
  categories: state.currentSalon.services,
  stylists: state.currentSalon.stylistList,
  products: state.product.response,
});

const EmailItemHoc = connect(mapStateToProps)(EmailItem);

export default EmailItemHoc;
